import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import styles from './styles.module.scss';

export default class Paginate extends React.Component {
  static propTypes = {
    page: PropTypes.number,
    pageCount: PropTypes.number,
  };

  static defaultProps = {
    page: 0,
    pageCount: 0,
  };

  render() {
    const { page, pageCount, ...props } = this.props;

    if (pageCount <= 1) {
      return null;
    }

    return (
      <div className={styles['wrapper']}>
        <ReactPaginate
          forcePage={page}
          pageCount={pageCount}
          previousLabel="&laquo;"
          nextLabel="&raquo;"
          breakLabel={<span className={styles['link']}>...</span>}
          marginPagesDisplayed={1}
          pageRangeDisplayed={5}
          containerClassName={styles['pagination']}
          pageClassName={styles['page']}
          pageLinkClassName={styles['link']}
          activeClassName={styles['active']}
          breakClassName={styles['break-me']}
          previousClassName={styles['page']}
          previousLinkClassName={styles['link']}
          nextClassName={styles['page']}
          nextLinkClassName={styles['link']}
          {...props}
        />
      </div>
    );
  }
}
